import React from 'react';
import PropTypes from 'prop-types';
import CustomCashOption from '../containers/CustomCashOption';
import ChangeModal from '../../../common/cashPay/ChangeModal';
import Money from '../../../common/money';

const CashOptions = ({
  cashAmounts,
  handleOptionSelect,
  paidAmount,
  changeAmount,
  charge,
  handleCustom,
}) => (
  <div className="c-cash-options u-mt">
    {cashAmounts.map(amount => (
      <button
        key={amount}
        type="button"
        className="c-cash-options__item"
        onClick={handleOptionSelect(amount)}
        data-automation-id={`button:cashOption:${amount}`}
      >
        <Money>{amount}</Money>
      </button>
    ))}

    <CustomCashOption onSubmit={handleCustom} />

    <ChangeModal
      close={charge}
      changeAmount={changeAmount}
      paidAmount={paidAmount}
      display-if={paidAmount}
    />
  </div>
);
CashOptions.propTypes = {
  cashAmounts: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleOptionSelect: PropTypes.func.isRequired,
  paidAmount: PropTypes.number.isRequired,
  changeAmount: PropTypes.number.isRequired,
  charge: PropTypes.func.isRequired,
  handleCustom: PropTypes.func.isRequired,
};
CashOptions.defaultProps = {
};

export default CashOptions;
